import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NedermanParameter } from 'app/backend/api';

@Component({
  selector: 'app-application-parameter',
  templateUrl: './application-parameter.component.html',
  styleUrls: ['./application-parameter.component.scss'],
})
export class ApplicationParameterComponent implements OnInit {
  @Input() parameters: NedermanParameter[];
  @Input() name: string;
  @Input() applicationName: string;

  @Output() submitParameters: EventEmitter<any> = new EventEmitter();
  @Output() goBack: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();

  public paramsForm: UntypedFormGroup;
  public isSubmitted = false;

  constructor(
    private fb: UntypedFormBuilder,
  ) { }

  ngOnInit() {
    // REMOVE GENERATED PARAMS
    this.parameters = this.parameters.filter(parameter => parameter.definition.type !== 'generated');
    // Sort by ordinal
    this.parameters = this.parameters.sort((a, b) => { return a.definition.ordinal - b.definition.ordinal; });
    this.paramsForm = this.fb.group({});

    this.parameters.forEach(param => {
      let control: UntypedFormControl;
      if (param.definition.type === 'Boolean') {
        const value = param.value === '1' || param.value === 'true' ? true : false;
        control = new UntypedFormControl(value);
      } else if (param.definition.type === 'Integer') {
        const value = param.value ? parseInt(param.value) : 0;
        control = new UntypedFormControl(value);
      } else if (param.definition.type === 'Float') {
        const value = param.value ? parseFloat(param.value) : 0.00;
        control = new UntypedFormControl(value);
      } else {
        control = new UntypedFormControl(param.value || '');
      }
      this.paramsForm.addControl(param.parameterId, control);
      if (param.definition.parentId) {
        this.paramsForm.get(param.definition.parentId).valueChanges.subscribe(depend => {
          if (depend === true) {
            if (param.definition.name === 'selfRegistrationDomain') {
              this.paramsForm.get(param.parameterId).setValidators([Validators.required,
              Validators.pattern(
                /^\s*(?:(?:\w+(?:-+\w+)*\.)+[a-z]+)\s*(?:,\s*(?:(?:\w+(?:-+\w+)*\.)+[a-z]+)\s*)*,?\s*$/
              )]
              );
            } else {
              this.paramsForm.get(param.parameterId).setValidators(Validators.required);
            }
          } else {
            this.paramsForm.get(param.parameterId).clearValidators();
          }
          this.paramsForm.get(param.parameterId).updateValueAndValidity();
        });
      }
      if (param.definition.status === 'required') {
        this.paramsForm.get(param.parameterId).setValidators(Validators.required);
      }
      if (param.definition.maxLength) {
        this.paramsForm.get(param.parameterId).setValidators(Validators.maxLength(param.definition.maxLength));
      }
      if (param.definition.minValue) {
        this.paramsForm.get(param.parameterId).setValidators(Validators.min(param.definition.minValue));
      }
      if (param.definition.maxValue) {
        this.paramsForm.get(param.parameterId).setValidators(Validators.max(param.definition.maxValue));
      }
    });
  }

  isReadonly(key: string, readonly: boolean) {
    if (readonly) {
      this.paramsForm.controls[key].setValue('');
    }
    return readonly;
  }

  submitParams() {
    if (this.paramsForm.valid) {
      const paramObjects = Object.keys(this.paramsForm.value).map(key => ({ parameterId: key, value: this.paramsForm.value[key] }));
      this.submitParameters.emit(paramObjects);
    } else {
      this.isSubmitted = true;
    }
  }

}
